export function formatPrice(type: string, price?: number, isUnacquiredPrice?: boolean): string {
  if (isUnacquiredPrice && type === "PARTS_ORDER_CAR") {
    return 'Getting reference price';
  }
  return price ? `${price.toLocaleString()}` : type === "PARTS_ORDER_CAR" ? 'Ask' : "-";
}
